import React from "react";
import AuthProvider from "./provider/AuthProvider";
import Routing from "./components/Routing";

const App = () => {
  return (
    <AuthProvider>
      <Routing />
    </AuthProvider>
  );
};

export default App;
